module.exports = __webpack_public_path__ + "img/packages/h7.3f0b8e.png";